<app-header [pageName]="pageName"></app-header>

<div class="page-header header-color">
  <div class="container">

    <div class="row">

      <div class="col-md-6">
        <h1 class="title">Valuations</h1>
        <p class="subtitle">Evaluation page where you can view and manage all your requested Properties
          Evaluations including status, results and notifications about the Properties Evaluations request</p>
      </div>

      <div class="col-md-6 d-flex justify-content-center">
        <img class="logo" src="../../assets/images/logo_white.png" alt="">
      </div>

    </div>

    <div class="row" *ngIf="viewValuations">
      <div class="col-12">
        <form>
          <div class="input-group">
            <input type="text" name="searchText" class="form-control search-input border-0 small"
              [(ngModel)]="valuationSearchText" placeholder="Search for event..." aria-label="Search"
              aria-describedby="basic-addon2">
            <div class="input-group-append">
              <button class="btn btn-primary btn-search" (click)="onValuationSearch()" type="button">
                <i class="fa fa-search fa-sm"></i>
              </button>
            </div>
          </div>
        </form>
      </div>
    </div>

  </div>
</div>

<div *ngIf="viewValuations" class="container-fluid mt-negative">

  <div class="row">

    <div id="sidebar" class="col-md-2 type_div">
      <div class="row ">
        <div class="card sidebar-card">
          <p class="ml"><b>Filter Valuations</b></p>
          <div class="form-check" *ngFor="let category of categories">
            <input class="form-check-input" [(ngModel)]="category.isSelected" (change)="onChecked($event)"
              type="checkbox" value={{category.value}} id="defaultCheck1">
            <label class="form-check-label" for="defaultCheck1">
              {{category.value}}
            </label>
          </div>
        </div>
      </div>
    </div>

    <div id="body-container" class="col">

      <div class="row" *ngIf="!isResults">
        <div class="col-md-12">
          <h2>No Evaluations available</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">All your requested and processed Property Evaluations will be displayed here.</p>
        </div>
      </div>

      <div class="row" *ngIf="searching && !searchResults">
        <div class="col-md-12">
          <h2>No records found</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">There are no results matching your search : <b>{{searchText}}</b></p>
        </div>
        <div class="col-md-12 text-center">
          <input class="btn btn-eval rounded-pill" type="button" value="Clear" (click)="getEvaluations(userGroup)">
        </div>
      </div>

      <div class="row" *ngIf="searching && searchResults">
        <div class="col-md-12">
          <h2>Search results:</h2>
        </div>
        <div class="col-md-12">
          <p class="subtitle">Search records found <b>( {{resultsValue}} )</b></p>
        </div>
      </div>

      <div class="row">
        <div class="col-md-12">
          <div class="row d-flex justify-content-center m-t-2" *ngIf="isLoading">
            <img class="loader" src="../../assets/images/loader.gif" alt="">
          </div>
        </div>
      </div>

      <div>
        <!-------------------------------->
        <div class="row card_div">
          <!-- <div class="col-sm-4" *ngFor="let source of propertiesData">
            <div (click)="onView(source, 'default')" class="card border-light mb-4 shadow propertyCard">
              <div class="card-body">
                <div class="vertical-center">
                  <div class="row">
                    <div class="col-md-4 nogutters d-flex justify-content-center">
                      <img class="event_logo rounded" src={{imageBaseUrl+source.property.image_url}} alt="">
                    </div>
                    <div class="col-md-8 nogutters">
                      <h4 class="cardHeading">{{source.property.propName}} - Valuation</h4>
                    </div>
                  </div>
                  <p class="text-right status">Status: {{source.status}}</p>

                  <hr class="hr">

                  <div class="row">
                    <p class="cardDescription">{{source.property.propDescription}}</p>
                  </div>
                </div>
                <img src="../../assets/images/arrow.svg" class="arrow" alt="">
              </div>
            </div>
          </div> -->

          <table *ngIf="isResults" class="mat-elevation-z8" mat-table [dataSource]="dataSource" matSort>

            <!-- Logo Column -->
            <ng-container matColumnDef="image_url">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Image </th>
              <td mat-cell *matCellDef="let row" (click)="onView(row, 'default')" class="pointer"> <img
                  class="event_logo rounded" src="{{ imageBaseUrl+row.property.image_url}}" alt=""> </td>
            </ng-container>

            <!-- Name Column -->
            <ng-container matColumnDef="propName">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Property Name </th>
              <td mat-cell *matCellDef="let row" (click)="onView(row, 'default')" class="pointer">
                {{row.property.propName}} </td>
            </ng-container>

            <!-- Status Column -->
            <ng-container matColumnDef="status">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Status </th>
              <td mat-cell *matCellDef="let row" (click)="onView(row, 'default')" class="pointer"> {{row.status}} </td>
            </ng-container>

            <!-- Description Column -->
            <ng-container matColumnDef="propDescription">
              <th mat-header-cell *matHeaderCellDef mat-sort-header> Property Description </th>
              <td mat-cell *matCellDef="let row" (click)="onView(row, 'default')" class="pointer">
                {{row.property.propDescription}} </td>
            </ng-container>

            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
            <tr mat-row *matRowDef="let row; columns: displayedColumns;">
            </tr>
          </table>

          <mat-paginator *ngIf="isResults" [pageSizeOptions]="[2, 5, 10, 25, 100]"></mat-paginator>
        </div>

        <!-- <div class="row card_div" *ngIf="isSorting">
          <div class="col-sm-4" *ngFor="let source of propertiesData">
            <div (click)="onView(source, 'searched')" class="card border-light mb-4 shadow propertyCard">
              <div class="card-body">
                <div class="vertical-center">
                  <div class="row">
                    <div class="col-md-4 nogutters d-flex justify-content-center">
                      <img class="event_logo rounded" src={{imageBaseUrl+source.property.image_url.S}} alt="">
                    </div>
                    <div class="col-md-8 nogutters">
                      <h4 class="cardHeading">{{source.property.propName.S}} - Valuation</h4>
                    </div>
                  </div>
                  <p class="text-right status">Status: {{source.status}}</p>
  
                  <hr class="hr">
  
                  <div class="row">
                    <p class="cardDescription">{{source.property.propDescription.S}}</p>
                  </div>
                </div>
                <img src="../../assets/images/arrow.svg" class="arrow" alt="">
              </div>
            </div>
          </div>
        </div> -->
      </div>

    </div>

  </div>

</div>

<div *ngIf="!viewValuations" class="container-fluid mt-negative">
  <router-outlet></router-outlet>
</div>

<!-- Modal -->
<div class="modal fade" [ngStyle]="{'display': openSuccessModal ? 'block' : 'none', 'opacity': 1}" role="dialog"
  aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog m-t-4" role="document">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Success valuation</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close" (click)="closeDialog()">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">
        {{state.success}}
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-dismiss="modal" (click)="closeDialog()">Close</button>
      </div>
    </div>
  </div>
</div>

<app-footer></app-footer>